import axios from "axios";
import { LocalStorageService } from "../CoreComponents/constants/service/LocalStorageService";


export const inkapi = axios.create({

    //  baseURL: 'http://localhost:4000/'
    // baseURL: 'https://devapiquote.theinkscribe.com'
    baseURL: 'https://api.quote.theinkscribe.com'
});

export const setAxiosDefauls = () => {

    inkapi.interceptors.request.use(
        onRequestFulfilled
        , onRequestRejected);

    inkapi.interceptors.response.use(
        onResponseFulfilled
        , onResponseRejected);

    inkapi.interceptors.request.use(
        onRequestFulfilled
        , onRequestRejected);

    inkapi.interceptors.response.use(
        onResponseFulfilled
        , onResponseRejected);
}

export const resetSession = () => {
    localStorage.remove("bearer-token");
    //history.push('/');
}

const onRequestFulfilled = (config) => {
    const localStorageService = LocalStorageService.getService();
    const token = localStorageService.getAccessToken("bearer-token");
    if (token && config.url != "/token") {
        config.headers = {
            "Authorization": "Bearer " + token,
            "Access-Control-Allow-Origin": "*"
        };
    }
    else {
        config.headers = {

            //   "Cache-Control": "no-cache"
            //  ,"Access-Control-Allow-Origin": "*"
            //  ,"Content-Type":"application/json"
            //  , "Pragma": "no-cache"
            //  , "X-Frame-Options": "SAMEORIGIN",
        };
    }
    return Promise.resolve(config);
}

const onRequestRejected = (error) => {
    return Promise.reject(error);
}

const onResponseFulfilled = (config) => {
    return Promise.resolve(config);
}

const onResponseRejected = (error) => {
    return Promise.reject(error);
}